import { Button } from '@dexma/ui-components';
import { ConfigFieldType } from 'adapter/in/common/form/types';
import { getOptionsFormByWidgetType } from 'adapter/in/dashboards/containers/EditDashboard/WidgetMenu/Panel/Configuration/Tabs/Options';
import { StyledActionsMenuWrapper } from 'adapter/in/dashboards/pages/Widget/ActionsMenu/style';
import i18n from 'asset/translation';
import { WidgetType } from 'domain/entity/widget';
import React, { ReactElement } from 'react';

type WidgetMenuProps = {
    show: boolean;
    onDelete: () => void;
    showOptions: boolean;
    onEdit?: (tab: ConfigFieldType) => void;
    onEditTextBlock?: () => void;
    widgetType?: WidgetType;
    isEditDisabled?: (tabPane: ConfigFieldType) => boolean;
};
export const WidgetActionsMenu = (props: WidgetMenuProps): ReactElement => {
    const { show, onDelete, onEdit, onEditTextBlock, isEditDisabled, widgetType, showOptions } = props;
    const hasOptions = widgetType !== undefined ? getOptionsFormByWidgetType(widgetType).length > 0 : false;
    return show ? (
        <StyledActionsMenuWrapper data-testid='widget-menu'>
            {widgetType !== WidgetType.RICH_TEXT && onEdit && isEditDisabled && (
                <Button
                    type='button'
                    kind='iconButton'
                    data-testid='edit-data'
                    tooltip={`${i18n.t('common.edit')} ${i18n.t('widgets.widgetMenu.data')}`}
                    onClick={() => {
                        onEdit(ConfigFieldType.DATA);
                    }}
                    iconBefore='settings'
                    isDisabled={isEditDisabled(ConfigFieldType.DATA)}
                    isCircle
                    iconAriaLabel={`${i18n.t('dashboards.edit.ariaLabel.widgetSettingIcon')}`}
                />
            )}

            {showOptions && hasOptions && onEdit && isEditDisabled && (
                <Button
                    type='button'
                    kind='iconButton'
                    tooltip={`${i18n.t('common.edit')} ${i18n.t('widgets.widgetMenu.options')}`}
                    data-testid='edit-options'
                    onClick={() => {
                        onEdit(ConfigFieldType.OPTIONS);
                    }}
                    iconBefore='edit'
                    isDisabled={isEditDisabled(ConfigFieldType.OPTIONS)}
                    isCircle
                    iconAriaLabel={i18n.t('dashboards.edit.ariaLabel.widgetEditOptions')}
                />
            )}

            {widgetType === WidgetType.RICH_TEXT && onEditTextBlock && (
                <Button
                    type='button'
                    kind='iconButton'
                    tooltip={`${i18n.t('common.edit')}`}
                    data-testid='edit-text-block'
                    onClick={() => {
                        onEditTextBlock();
                    }}
                    iconBefore='edit'
                    isCircle
                    iconAriaLabel={i18n.t('dashboards.edit.ariaLabel.widgetEditOptions')}
                />
            )}

            <Button
                type='button'
                kind='iconButton'
                data-testid='delete-widget'
                iconBefore='delete'
                variant='destructive'
                isCircle
                onClick={() => onDelete()}
                iconAriaLabel={i18n.t('dashboards.edit.ariaLabel.deleteWidget')}
            />
        </StyledActionsMenuWrapper>
    ) : (
        <></>
    );
};

export default WidgetActionsMenu;
